/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Vendor_Return_Waiting_On_SupplierInputs */

const en_vendor_return_waiting_on_supplier = /** @type {(inputs: Vendor_Return_Waiting_On_SupplierInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on the supplier · confirmation · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on the supplier · confirmation · since {since}" |
*
* @param {Vendor_Return_Waiting_On_SupplierInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const vendor_return_waiting_on_supplier = /** @type {((inputs: Vendor_Return_Waiting_On_SupplierInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vendor_Return_Waiting_On_SupplierInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_vendor_return_waiting_on_supplier(inputs)
});